import React from 'react';
import PropTypes from 'prop-types';

import { propTypes as linkPropTypes } from '../../../01_atoms/Link';
import QuickLinkItem from '../../../02_molecules/QuickLinkItem';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

class BBQuickLinks extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { links, behaviorSettings = null, uuid = null } = this.props;
    const colors = ['green', 'maroon', 'red', 'turquoise'];

    if (!(links && links.length)) {
      return null;
    }

    const classes = [
      'bb',
      'bb-quick-links',
      styles['bb-quick-links'],
      generateClassNameByBehaviorSettings(behaviorSettings),
    ];

    return (
      <div
        className={classes.join(' ')}
        id={uuid}
        // Hide BBSidebarTableOfContents when it is nearby the element.
        data-toc="hide"
      >
        <div className="container">
          <div className="row">
            {links.map(
              (link, index) =>
                link.button &&
                link.button.nextLink &&
                link.button.nextLink.url && (
                  <div className="col-6 col-lg-3" key={link.button.label}>
                    <QuickLinkItem
                      button={link.button}
                      image={link.image}
                      className={colors[index]}
                    />
                  </div>
                ),
            )}
          </div>
        </div>
      </div>
    );
  }
}

BBQuickLinks.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      button: PropTypes.shape({
        label: PropTypes.string,
        nextLink: PropTypes.shape(linkPropTypes),
      }),
      image: PropTypes.shape({
        url: PropTypes.string,
        alt: PropTypes.string,
      }),
    }),
  ).isRequired,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

export default BBQuickLinks;
